import React from "react";
import { CheckCircleOutlined } from "@ant-design/icons";
import { getInfoForRole } from "../Components/Logics/retrainCalculations";
import store from "../Store/configureStore";
import * as actions from "../Store/Actions/index";

// icons to return based on status
const checkMark = <CheckCircleOutlined style={{ fontSize: "1em" }} theme="twoTone" twoToneColor="#52c41a" />;

// gets icon for a panel for a role in the retraining tab
const getIconRole = (role) => {
  let status;
  const roleDetails = getInfoForRole(role);
  if (roleDetails.number && roleDetails.wage && roleDetails.benefit && roleDetails.hours) {
    status = "good";
  } else {
    status = "okay";
  }

  if (role === "coder") {
    store.dispatch(actions.setCoderStatus(status === "good"));
  }
  
  return status;
};

// gets icon for the "other" panel in retraining tab
const getIconRetrainOther = (data) => {
  if (data.othercosts) {
    return "good";
  }
  return "okay";
};

// gets icon for system it cost
const getIconSystemIt = (data) => {
  if (!data["one-time-software-installation-cost"] || !data["annual-fee"]) {
    return "okay";
  }
  return "good";
};

// gets icon for system personnel
const getIconSystemPersonnel = (data) => {
  if (
    !data["number-it-personnel"] ||
    !data["wage-it-personnel"] ||
    !data["hourly-benefit-amount"] ||
    !data["retraining-hours"]
  ) {
    return "okay";
  }
  return "good";
};

// gets icon for system other
const getIconSystemOther = (data) => {
  if (data["other-system-cost"]) {
    return "good";
  }
  return "okay";
};

// gets icon for prod loss timeline
const getIconProdLossTimeline = (data) => {
  if (
    data["working-hours-per-day"] &&
    data["min-break-in-period"] &&
    data["max-break-in-period"] &&
    data["working-days-per-month"]
  ) {
    return "good";
  }
  return "bad";
  //return "okay"
};

// gets icon for productivity change
const getIconProdChange = (data) => {
  if (data["coding-time-a"] && data["coding-time-b"]) {
    return "good";
  }
  return "bad";
};

// default method for retrieving an icon, calls another method based upon the option
export const getIcon = (data, option) => {
  let status;

  switch (option) {
    case "role":
      status = getIconRole(data);
      break;
    case "retrainOther":
      status = getIconRetrainOther(data);
      break;
    case "systemIt":
      status = getIconSystemIt(data);
      break;
    case "systemPersonnel":
      status = getIconSystemPersonnel(data);
      break;
    case "systemOther":
      status = getIconSystemOther(data);
      break;
    case "prodLossTimeline":
      status = getIconProdLossTimeline(data);
      break;
    case "prodChange":
      status = getIconProdChange(data);
      break;
    default:
      return checkMark;
  }

  if (status === "good") {
    return checkMark;
  } else if (status === "okay") {
    return "";
  }
  return <p style={{ color: "red" }}>REQUIRED</p>;
};